import takeScreenshot, {
  extensionExists as _extensionExists
} from './extensionScreenshot';
import {
  hideBeforeScreenshot,
  afterScreenshot as _afterScreenshot
} from './prePostScreenshot';
import getScreenshotPolyfill from './screenshotPolyfill';
import { generateCoordinates as generatePinCoordinates } from '../screenshotPinning';
import { handleScreenshot as updateTaskScreenshot } from '../screenshotTaskUpdate';

import { getBugherd } from '../models/Application';
import { SCREENSHOT_NOT_SUPPORTED } from '../models/ScreenshotCaptureError';
import PropTypes from 'prop-types';

export const captureScreen = async ({
  screenShotServerAccess,
  beforeScreenshot = hideBeforeScreenshot,
  afterScreenshot = _afterScreenshot,
  requestScreenshotDataURI = getBugherd().requestScreenshotDataURI,
  screenshotPolyfill = getScreenshotPolyfill,
  extensionExists = _extensionExists,
  legacy = false
}) => {
  const shadowDom = window?.BUGHERD_REACT_APP_SIDEBAR_MOUNT?.getRootNode();
  const sidebarContainer = shadowDom?.getElementById('sidebar-root');
  try {
    if (sidebarContainer) {
      sidebarContainer.style.display = 'none';
    }
    await beforeScreenshot();
    const screenshotPolyfillData = await screenshotPolyfill();
    if (await extensionExists()) {
      const details = await takeScreenshot(
        requestScreenshotDataURI,
        afterScreenshot,
        legacy
      ).catch(failure => {
        if (screenShotServerAccess) {
          return screenshotPolyfill();
        }
        afterScreenshot();
        return { error: failure, ...screenshotPolyfillData };
      });
      return Promise.resolve({ ...details, ...screenshotPolyfillData });
    }
    if (screenShotServerAccess) {
      return screenshotPolyfill();
    }
    afterScreenshot();
    return Promise.resolve({
      error: SCREENSHOT_NOT_SUPPORTED,
      ...screenshotPolyfillData
    });
  } catch (error) {
    console.error(error);
    return Promise.reject(error);
  } finally {
    if (sidebarContainer) {
      sidebarContainer.style.display = 'block';
    }
  }
};

captureScreen.proptype = {
  screenShotServerAccess: PropTypes.bool.isRequired
};

export { generatePinCoordinates, updateTaskScreenshot };
